<template>
	<div v-if="isActive || selected" class="list-group-item col-xs-12" :class="{disabled: remainingForFreeShipping && shippingMethod.id === 20, active: this.selected && this.isActive}">
		<div class="col-xs-12 shipping-header">
			<label class="radio-checkbox-label radio-inline col-xs-12 pr-0" :class="{'mb-3': !(remainingForFreeShipping && shippingMethod.id === 20)}">
				<input class="checkbox" type="radio" :checked="selected" />
				<span class="checkbox-custom">
					<span v-if="selected && isActive" class="checkbox-dot" />
					<span v-else-if="selected && ! isActive" class="glyphicon glyphicon-ok ok-mark" />
				</span>
				<span v-if="cart.rows[0].product.id == 391620" class="col-xs-9 shipping-name">
					Kvitto via e-post
				</span>
				<span v-else class="col-xs-9 shipping-name">
					{{ shippingMethod.name }}
					<preorder-info v-if="! isReleased" />
				</span>
				<div v-if="isActive" class="pull-right">
					<span v-if="hasRebate && price < 130 && price > 0" class="has-rebate">{{ formattedPrice }}</span>
					<span>{{ priceToPayIsZero ? "0 kr" : formattedPrice }}</span>
				</div>
				<span v-else class="pull-right">Ändra</span>
			</label>
			<div v-if="shippingMethod.id === 20 && remainingForFreeShipping" class="ml-5 col-xs-12 no-col-padding" :class="{ 'ap-br': hasOptions }" style="margin-top: -5px;">
				<small class="sub-title ml-5">{{ remainingForFreeShipping }}</small>
			</div>

		</div>
		<div v-if="! isDownload" class="shipping-stock-delivery col-xs-12">
			<div class="expected-delivery col-xs-9 col-md-10">
				<span v-if="! (hasOptions && selected) || ! isActive" :class="['stock-icon', stockClass]" />
				<p v-if="! availableOptions || (! selected || ! isActive)" class="sub-title">
					{{ getDeliveryInfo }}
				</p>
			</div>
			<div v-if="isActive" class="col-xs-3 col-md-2 pr-0">
				<img v-if="shippingMethod.imageUrl"
					:src="shippingMethod.imageUrl"
					class="shipping-icon"
					alt="shipping-icon"
				/>
			</div>
		</div>
		<template v-if="hasOptions && selected && isActive">
			<br>
			<dropdown-select :value="shippingMethodOptions[selectedDropdownIndex]" :items="shippingMethodOptions" fullWidth @select="handleDropdownSelect" />
		</template>
		<span v-if="selected && isActive && shippingMethod.label != getDeliveryInfo" class="list-group-item-text sub-title">
			{{ shippingMethod.label }}
		</span>
		<div v-if="selected && isActive && shippingMethod.isPostnordPallet" class="postnord-time-slots">
			<span class="sub-title semibold">Leveranstider för ditt postnummer</span>
			<div v-for="(timeSlot, index) in shippingMethod.postnordPalletTimeSlots" class="time-slot" :key="'time-slot-' + index">
				{{ timeSlot.day }}
				<span class="small">{{ timeSlot.timeRange }}</span>
			</div>
			<span class="sub-title">{{ tp('BOOKING') }}</span>
		</div>
	</div>
</template>

<script>
import bus from 'eventbus';
import { mapState } from 'vuex';
import stockUtils from 'utils/stock';
import { formatPrice, releaseToString, formatProductPrice } from 'utils';
import businessVariables from 'businessVariables';
import localSessionStorage from 'localSessionStorage';
import { getCartSum, hasUnreleasedProducts } from 'utils/cart';
import { t } from 'datastore/i18n';

export default {
	props: {
		cart: {
			type: Object,
			required: true,
		},
		shippingMethod: {
			type: Object,
			required: true,
		},
		selectedMethodId: {
			type: Number,
			default: null,
		},
		selectedZipCode: {
			type: Number,
		},
		stockAvailability: {
			type: Object,
			required: true,
		},
		selectedShippingOption: {},
		isLastRow: {
			type: Boolean,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
		numberOfProductsSentFromStore: {
			type: Number,
			default: 0,
		},
		firstShippingMethod: {
			type: Boolean,
			default: false,
		},
		isAllProductsSentFromStore: {
			type: Boolean
		},
		canShipNow: {
			type: Boolean
		},
		isDownload: {
			type: Boolean,
			default: false,
		},
		normalShippingPrice: {},
		involvesShipFromStore: {
			type: Boolean
		},
	},
	data() {
		return {
			todaysDate: new Date(),
			optionSelectorOpen: false,
			selectedPerk: null,
			selectedDropdownIndex: 0,
		};
	},
	mounted () {
		if (this.selected && this.shippingMethod.optionInfo && this.shippingMethod.optionInfo.defaultToFirstOption && ! this.selectedShippingOption && this.availableOptions && ! this.isAllProductsSentFromStore) {
			this.handlePreSelectedOption();
		}
		bus.$on('checkout:setperk', this.setPerk);
	},
	beforeDestroy() {
		bus.$off('checkout:setperk', this.setPerk);
	},
	methods: {
		tc: t.prefix('CHECKOUT.STOCK'),
		tp: t.prefix('POSTNORD'),
		setPerk (perk) {
			this.selectedPerk = perk;
		},
		handleDropdownSelect (value) {
			this.selectedDropdownIndex = value.index;
			this.selectOption(this.availableOptions[this.selectedDropdownIndex]);
		},
		handlePreSelectedOption () {
			this.selectedDropdownIndex = 0;

			let checkoutData = localSessionStorage.get('checkoutData');
			if (checkoutData) {
				checkoutData = JSON.parse(checkoutData);
				if (checkoutData?.returningFromBriqpay && ! checkoutData.isStoreReservation) {
					const found = this.availableOptions.findIndex((option) => option.name === checkoutData.selectedShippingOption.name);
					this.selectedDropdownIndex = found;
				}
			}

			this.selectOption(this.availableOptions[this.selectedDropdownIndex]);
		},
		selectOption (option) {
			console.log('selectOption');

			this.$emit('update:selectedShippingOption', option);
			this.optionSelectorOpen = false;
		},
		getUnreleasedDate () {
			const today = new Date();
			let prodRelease = null;
			this.cart.rows.forEach(row => {
				if (prodRelease === null) {
					prodRelease = row.product.release;
				}
				const date = new Date(row.product.release.timestamp * 1000);
				if (date > today) {
					prodRelease = row.product.release;
				}
			});
			return releaseToString(prodRelease);
		},
	},
	computed: {
		selectedOptionIsAvailable () {
			console.log("selectedOptionIsAvailable????? vad gör denna?");
			if (this.availableOptions && this.selectedShippingOption) {
				return this.availableOptions.some(el => el.value === this.selectedShippingOption.value);
			}
			return false;
		},
		selected () {
			return this.selectedMethodId === this.shippingMethod.id;
		},
		availableOptions () {
			return this.shippingMethod.options;
		},
		price () {
			if (this.user.settings.show_prices_excluding_vat) {
				return 0.8*this.shippingMethod.price;
			} else {
				return this.shippingMethod.price;
			}
		},
		formattedPrice () {
			const priceObj = {
				price: this.shippingMethod.price,
				vat: 0.2*this.shippingMethod.price,
				currency: 'SEK',
			};
			return formatProductPrice(priceObj, this.user.settings.show_prices_excluding_vat);
		},
		priceToPayIsZero () {
			if (! this.selectedPerk || this.price > 130) {
				return false;
			} else {
				return true;
			}
		},
		hasRebate () {
			if (! this.selectedPerk) {
				return false;
			} else {
				return true;
			}
		},
		getDeliveryInfo () {
			if ((this.cartHasUnreleasedProducts && !(this.selected && this.selectedShippingOption)) || this.stockAvailability.releaseDate) {
				return 'Release ' + this.getUnreleasedDate();
			} else if (this.displayOutOfStock) {
				return this.isAllProductsSentFromStore ? this.tc('STORE_SHIPPING_ASAP') : (!this.stockAvailability.inWebStock ? this.tc('STORE_OUT_OF_STOCK') : this.tc('WAREHOUSE_SHIPPING_ASAP'));
			}
			if (this.availableOptions) {
				return this.availableOptions[this.selectedDropdownIndex].label;
			} else {
				return this.shippingMethod.defaultEstimation;
			}
		},
		cartSum () {
			return getCartSum(this.cart);
		},
		remainingForFreeShipping () {
			if (this.shippingMethod.id === 20) {
				const currency = 'SEK';
				const sumRemaining = businessVariables.minimumPurchaseForFreeShipping[currency] - this.cartSum;
				let isDisabled = false;
				if (sumRemaining <= 0) {
					return null;
				} else {
					isDisabled = true;
				}
				return formatPrice(sumRemaining, currency) + ' kvar till fri frakt';
			} else { return null; }
		},
		showSubTitle () {
			if (this.shippingMethod.options) {
				return this.shippingMethod.options[0].description !== '';
			}
			return false;
		},
		...mapState({
			user: 'user',
		}),
		hasOptions () {
			return this.shippingMethod.options && this.shippingMethod.options.length > 0;
		},
		cartHasUnreleasedProducts () {
			return hasUnreleasedProducts(this.cart);
		},
		isReleased () {
			return stockUtils.isReleased(this.stockAvailability.releaseDate);
		},
		displayOutOfStock () {
			return (!this.stockAvailability.inWebStock || (this.isAllProductsSentFromStore && !this.firstShippingMethod) || (this.numberOfProductsSentFromStore > 0 && !this.firstShippingMethod) || (! this.canShipNow && ! this.firstShippingMethod));
		},
		stockClass () {
			return this.displayOutOfStock ? 'stock-icon-outofstock-incentral' : 'stock-icon-in-supplier-stock';
		},
		shippingMethodOptions () {
			return this.availableOptions;
			/*return this.availableOptions.map((value, index) => {
				return {
					index: index,
					label: ! this.stockAvailability.inWebStock && (this.shippingMethod.id == 26 || this.shippingMethod.id == 29) ? this.tc('STORE_OUT_OF_STOCK') : value.description != '' ? value.description : value.name,

					description: value.properties["directions.long"] ? value.properties["directions.long"] : value.addressLine1 ? value.addressLine1 + ', ' + value.postalCode + ' ' + value.city : ! this.stockAvailability.inWebStock && (this.shippingMethod.id == 26 || this.shippingMethod.id == 29) ? '' : null
				};
			});*/
		},
	},
	watch: {
		selected () {
			if (this.selected) {
				if (this.hasOptions) {
					this.handlePreSelectedOption();
				} else {
					this.selectOption(null);
				}
			}
		},
	},
};
</script>
